import {createUseStyles} from 'react-jss';
import Spacing from '../style-helper/Spacing';

export default createUseStyles({
  fieldLabel: props => ({
    fontWeight:
      props.type === 'checkbox'
        ? props.theme.checkbox?.inputLabelFontWeight || props.theme.inputLabelFontWeight || props.theme.boldFontWeight
        : props.theme.inputLabelFontWeight || props.theme.boldFontWeight,
    verticalAlign: 'middle',
    float: 'none',
    lineHeight: 'inherit',
    display: 'block',
    marginBottom: !props.isRadioButton && Spacing.half,
    marginLeft: !props.isRadioButton && Spacing.single,
    '&:before': {
      content: props.required ? '"*"' : 'none',
      position: 'absolute',
      left: 0,
    },
  }),
  optional: {
    color: '#808080',
  },
});
